// extracted by mini-css-extract-plugin
export default {"marginStyle":"Margin_marginStyle__pmkyH"};